module.exports = __webpack_public_path__ + "img/PT246.c3c97d47.png";